module.exports = __webpack_public_path__ + "static/media/womanbestTrophy.3801b506.png";